<template>
   <div class="box">
      <div style="margin: 3% auto 30px auto;">
          <p style="text-align:center;font-size: 80px; ">{{title}}</p>
      </div>         
      <div>
          <p style="text-align:center;font-size: 40px; ">请扫码关注微信小程序及时关注审车流程</p>
      </div>       
      <div class="qrimg" >
          <center>
            <el-image :src="this.qrImgSrc">
            <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
            </div>
            </el-image>          
          </center>
      </div>
      <div>
          <p style="text-align:center;font-size: 60px; ">{{carInfo}}</p>
      </div>
  </div>
</template>
<script>
import { getWebSocketUrl } from "@/js/globalConfig.js";
var mySocket = null;
var timer = null;
var timerList = [];

export default {
  data() {
    return {
      title:"检测站欢迎您",
      carInfo:"",
      currentCar: "",
      currentInfo:{
          optType: "Station",
          optCode: "0",
      },
      qrImgSrc: "",
      user: null,
      UserCode: null,
      resData: "",
    };
  },
  created() {
    this.user = this.$store.getters["user/UserInfo"];
    this.UserCode = this.user.UserCode;
    var that = this;
    
    /* 2022-08-08：不再使用websocket
    getWebSocketUrl().then(() => {
      console.info(that.$store.getters["globalConfig/WebSocketUrl"]);
      that.webSocket();
    }); */
  },
  mounted() {
    this.title = this.user.StationName + "欢迎您";
    this.currentCar = "";
    this.currentInfo.optType = "Station";
    this.currentInfo.optCode = this.user.OwnedStationCode;      
    this.getBindInfo();   
  },
  beforeDestroy() {
    this.intervalEnd();
    if (mySocket!=null)
    {
      mySocket.close();
    }
  },
  props: [],
  methods: {
    nextBindInfo(){
      console.log("nextBindInfo");
      console.log(this.user);
      this.$axios
        .post(
          "/Broadcast/GetWechatBindInfo",
          { stationid: this.user.OwnedStationCode },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then(
          function (res) {
            if (res.data.Code == "10000") {
              //有订单
              if (this.resData!=res.data.Data){
                this.resData = res.data.Data;
                let plateNumber = this.resData.split("|")[0];
                let orderCode = this.resData.split("|")[1];              
                this.currentCar = plateNumber;
                this.currentInfo.optType = "Order";
                this.currentInfo.optCode = orderCode; 
                this.getBindInfo();
              }
              else
              {
                setTimeout(() => {
                  this.nextBindInfo();
                }, 3000);                   
              }
            } else if(res.data.Code == "10001") {
              //无订单
              if (this.resData!=res.data.Data){
                this.resData = res.data.Data;
                this.currentCar = "";
                this.currentInfo.optType = "Station";
                this.currentInfo.optCode = this.user.OwnedStationCode;      
                this.getBindInfo();
              }
              else
              {
                setTimeout(() => {
                  this.nextBindInfo();
                }, 3000);                   
              }              
            }
          }.bind(this)
        ) //bind(this)可以不用
        .catch(
          function (err) {
            if (err.response) {
              console.log("服务端错误！");
            }
          }.bind(this)
        ); //bind(this)可以不用      
    },
    getBindInfo(){
        this.$axios
            .post("/Charge/GetWeChatBindImage", this.currentInfo, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            })
            .then(
            function (res) {
                if (res.data.Code=10000){
                    this.qrImgSrc = "data:image/png;base64," + res.data.Data;
                    if (this.currentCar == "")
                    {
                        this.carInfo = "";
                    }
                    else
                    {
                        this.carInfo = "车牌号:" + this.currentCar;
                    }
                }
                else
                {
                    this.$message({
                        message: "获取图片失败:" + res.data.Message ,
                        type: "error",
                    });                    
                }
                setTimeout(() => {
                  this.nextBindInfo();
                }, 5000);                 
            }.bind(this)
            ) //bind(this)可以不用
            .catch(
            function (err) {
                if (err.response) {
                    this.$message({
                        message: "服务器端错误，数据加载失败！",
                        type: "error",
                    });
                }
            }.bind(this)
            ); //bind(this)可以不用        
    },
    intervalEnd() {
      if (timer) {
        timerList.forEach((item, index) => {
          clearInterval(item);
        });
        timerList = [];
        timer = null;
      }
    },    
    webSocket() {
      if (typeof WebSocket == "undefined") {
        this.$notify({
          title: "提示",
          message: "当前浏览器无法接收实时报警信息，请使用谷歌浏览器！",
          type: "warning",
          position: "bottom-right",
          duration: 0,
        });
      } else {
        let that = this;
        // if (timer) {
        //   clearInterval(timer);
        // } else {
        // }
        if (mySocket != null) {
          mySocket = null;
        }
        // 获取token保存到vuex中的用户信息，此处仅适用于本项目，注意删除或修改
        // console.info(userInfo);
        // 实例化socket，这里我把用户名传给了后台，使后台能判断要把消息发给哪个用户，其实也可以后台直接获取用户IP来判断并推送
        const socketUrl = this.$store.getters["globalConfig/WebSocketUrl"];
        mySocket = new WebSocket(socketUrl);
        // 监听socket打开
        mySocket.onopen = () => {
          //console.log("浏览器WebSocket已打开");
          //console.log(Date() + this.UserCode);
          mySocket.send("$$$" + this.UserCode+"1");
          this.intervalEnd();
          if (timer == null) {
            timer = window.setInterval(() => {
              try {
                if (mySocket.readyState == mySocket.CLOSED) {
                  console.info(mySocket.readyState);
                  console.info("断开了" + Date());
                }
                if (mySocket.readyState != mySocket.OPEN) {
                } else {
                  mySocket.send("test");
                }
              } catch (err) {
                console.info(mySocket.readyState);
                //console.log("断开了：");
                //console.log(Date());
              }
            }, 10000);
            console.info(timer);
            timerList.push(timer);
          }
        };
        // 监听socket消息接收
        mySocket.onmessage = function (msg) {    
          // 转换为json对象
          const data = JSON.parse(msg.data);
          /*
          that.$notify({
            title: data.MessageTitle,
            message: data.Message,
            type: data.MessageType,
            duration: 0,
            offset: 50,
            position: "bottom-right",
            onClick: () => {
              that.$router.push(data.Url);
            },
          });*/          
          let plateNumber = data.MessageTitle;
          let orderCode = data.Message;
          //请求微信绑定信息
          that.currentCar = plateNumber;
          that.currentInfo.optType = "Order";
          that.currentInfo.optCode = orderCode; 
          that.getBindInfo();           
        };
        // 监听socket错误
        mySocket.onerror = function () {
          // that.$notify({
          //   title: "错误",
          //   message: "服务器错误，无法接收实时报警信息，请刷新页面尝试重连",
          //   type: "error",
          //   position: "bottom-right",
          //   duration: 0,
          //   offset: 50
          // });
          // that.$notify({
          //   title: "消息提示服务连接关闭",
          //   message: "消息提示服务连接关闭，请点击尝试重连",
          //   type: "error",
          //   position: "bottom-right",
          //   duration: 0,
          //   offset: 50,
          //   showClose: false,
          //   onClick: () => {
          //     that.$router.go(0);
          //   },
          // });
        };
        // 监听socket关闭
        mySocket.onclose = (e) => {
          //console.log("WebSocket已关闭");
          //console.log(Date());
          //console.log(
          //  "websocket 断开: " + e.code + " " + e.reason + " " + e.wasClean
          //);
          //console.log(e);
          //if (window.name != "") {
            this.webSocket();  //断开尝试重连
          //}
          // that.$notify({
          //   title: "连接关闭",
          //   message: "消息提示连接关闭，请点击尝试重连",
          //   type: "error",
          //   position: "bottom-right",
          //   duration: 0,
          //   offset: 50,
          //   showClose: false,
          //   onClick: () => {
          //     that.$router.go(0);
          //   },
          // });
          // clearInterval(that.timer);
        };
      }
    },    
  },
  components: {
      
  }
};
</script>

<style>
.box{
    position:absolute;
    width:100%; 
		height:100%;  
    color:white;
    font-weight:bolder;    
    background:#000 ;
}
.qrimg{
    margin: 2% auto 30px auto;
    width: 800px;
}
</style>


// WEBPACK FOOTER //
// src/components/customerWeChatBind.vue